module.exports = __webpack_public_path__ + "img/img7.a289c931.svg";